import { Icon } from './icon';

export const IconSearch = () => (
  <Icon>
    <path d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z" />
    <path d="M22 22L18 18" />
  </Icon>
);
